import styled from "styled-components";

export const AlertMessageBox = styled.div`
  gap: 20px;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  svg {
    path {
      fill: #16baa4;
    }
  }
`;

export const AlertMessageText = styled.p`
  gap: 8px;
  color: ${(props) => props.theme.colors.black80};
  display: flex;
  font-size: 2rem;
  font-size: 1.4rem;
  text-align: center;
  font-weight: 800;
  line-height: 120%;
  flex-direction: column;
`;

export const Highlight = styled.span`
  color: ${(props) => props.theme.colors.black80} !important;
`;
